import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const NotificationGlyph = /*#__PURE__*/createElement("g", {
  id: "notification"
}, /*#__PURE__*/createElement("path", {
  d: "M42,32.1c-0.7,0-1.3-0.2-1.8-0.7c-0.5-0.4-0.8-1.1-0.8-1.8c0-0.7,0.2-1.3,0.7-1.8s1.1-0.7,1.8-0.7 s1.3,0.2,1.8,0.7s0.7,1.1,0.7,1.8c0,0.8-0.2,1.4-0.7,1.8S42.7,32.1,42,32.1z"
}), /*#__PURE__*/createElement("path", {
  d: "M33.5,69c-0.2,0-0.4,0-0.6-0.1c-0.6-0.2-0.9-0.8-0.9-1.4v-8H20c-2.5,0-4.5-2-4.5-4.5V24c0-2.5,2-4.5,4.5-4.5 h44c2.5,0,4.5,2,4.5,4.5v31c0,2.5-2,4.5-4.5,4.5H43.6l-9.1,9.1C34.3,68.8,33.9,69,33.5,69z M20,22.5c-0.8,0-1.5,0.7-1.5,1.5v31 c0,0.8,0.7,1.5,1.5,1.5h13.5c0.8,0,1.5,0.7,1.5,1.5v5.9l6.9-6.9c0.3-0.3,0.7-0.4,1.1-0.4h21c0.8,0,1.5-0.7,1.5-1.5V24 c0-0.8-0.7-1.5-1.5-1.5H20z"
}), /*#__PURE__*/createElement("path", {
  d: "M44,47V36c0-1.1-0.9-2-2-2h-2c-1.1,0-2,0.9-2,2s0.9,2,2,2v9c-1.1,0-2,0.9-2,2s0.9,2,2,2h4c1.1,0,2-0.9,2-2 S45.1,47,44,47z"
}));
const Notification = createSvg({
  name: 'notification',
  path: NotificationGlyph
});

export default Notification;
export { NotificationGlyph };
